import BrokersApi from '../BrokersApi';
import * as types from './ActionTypes';
import IBrokerFirm from '../firm/IBrokerFirm';

function newBrokerFirmSuccess(result: any) {
    return { type: types.NEW_BROKER_FIRM_SUCCESS, result };
}

export function newBrokerFirm(parentId: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.newBrokerFirm(parentId).then((result: any) => {
            dispatch(newBrokerFirmSuccess(result));
        });
}

function createBrokerFirmSuccess(result: IBrokerFirm) {
    return { type: types.CREATE_BROKER_FIRM_SUCCESS, result };
}

export function createBrokerFirm(data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.createBrokerFirm(data).then((result: IBrokerFirm) => {
            dispatch(createBrokerFirmSuccess(result));
        });
}

function editBrokerFirmSuccess(result: any) {
    return { type: types.EDIT_BROKER_FIRM_SUCCESS, result };
}

export function editBrokerFirm(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.editBrokerFirm(id).then((result: any) => {
            dispatch(editBrokerFirmSuccess(result));
        });
}

function updateBrokerFirmSuccess(result: IBrokerFirm) {
    return { type: types.UPDATE_BROKER_FIRM_SUCCESS, result };
}

export function updateBrokerFirm(id: number, data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.updateBrokerFirm(id, data).then((result: IBrokerFirm) => {
            dispatch(updateBrokerFirmSuccess(result));
        });
}
